import * as api from 'api/menu/PostMenuSearchV1';
import Season from 'classes/Menu/Search/Season';
import getSeasonalityCode from 'functions/getSeasonalityCode';
import * as Icon from 'types/Icon/Icon';

export default class SeasonList {
	public all: Season[] = [];

	public constructor(input?: api.Season[]) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public mapToIcons(): (Icon.Type | null)[] {
		return this.all.map((e: Season) => {
			return e.mapToIcon();
		});
	}

	public getSeasonalityCode() {
		return getSeasonalityCode(this.all);
	}

	public mapFromApi(input: api.Season[] | null) {
		if (input) {
			for (const i of input) {
				const season: Season = new Season(i);
				this.all.push(season);
			}
		}
	}
}
